
export enum CountryCurrency {
    FI = 'EUR',
    NO = 'NOK',
    ZA = 'ZAR',
    US = 'USD', // Added for USA
  }